import { FOMO_ELEMENTS } from "../../../constants/fomo-elements-constants";

export const SOURCE = {
    MY_BOOKINGS: "MY_BOOKINGS",
    LISTING: "LISTING",
    WISHLIST: "WISHLIST",
    WISHLIST_SIMILAR_CARS: "WISHLIST_SIMILAR_CARS",
    SIMILAR_CARS: "SIMILAR_CARS",
    RECENT_CARS: "RECENT_CARS",
    FEATURED_CARS: "FEATURED_CARS"
};

export const SECTION_SOURCE = {
    CAROUSEL: "CAROUSEL"
};

export const BOOKING_STATE = {
    CANCEL: "CANCEL",
    EXPIRED: "EXPIRED",
    BOOKED: "BOOKED"
};

export const getFomoStyle = (key) => {
    switch (key) {
    case FOMO_ELEMENTS.VIEWED:
        return {
            wrapperStyle: "styles.viewedSticker",
            textStyle: "styles.viewedText"
        };
    case FOMO_ELEMENTS.PRICE_DROP:
        return {
            wrapperStyle: "styles.priceDropSticker",
            textStyle: "styles.priceDropText"
        };
    case FOMO_ELEMENTS.WISHLISTED:
        return {
            wrapperStyle: "styles.wishlistSticker",
            textStyle: "styles.wishlistText"
        };
    default:
        return "";
    }
};
